import styled from 'styled-components';
import { Tag } from '@amzn/storm-ui';

export const MarginlessTag = styled(Tag)`
  margin: 0;
`;
